import { ajax } from '../http.js'

export default {

    /**
     * 获取展览列表方法
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getExhibitionInfo(searchParams) {
        return ajax('frontapi/expo/main/list', 'GET', searchParams);
    },
    /**
     * 获取藏品方法
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getArtInfo(searchParams) {
        return ajax('frontapi/museumCollection/classify/list', 'GET', searchParams);
    },
    /**
     * 获取新闻通告方法
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getNewsInfo(searchParams) {
        return ajax('frontapi/news/information/list', 'GET', searchParams);
    },
    /**
     * 获取公共活动方法
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getPublicActivity(searchParams) {
        return ajax('frontapi/edu/main/list', 'GET', searchParams);
    },
    /**
     * 获取美术馆简介及开馆时间相关信息
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getArtBriefInfo(searchParams) {
        return ajax('frontapi/service/information/getDetail', 'GET', searchParams);
    },

    /**
     * 获取友情链接方法
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getYouqinglianjie(searchParams) {
        return ajax('frontapi/home/main/list', 'GET', searchParams);
    },
    /**
     * 获取banner区轮播列表方法
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getBannerInfo(searchParams) {
        return ajax('frontapi/home/main/bannerList', 'GET', searchParams);
    },
    /**
     * 获取地图信息
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getServiceGuide(searchParams) {
        return ajax('frontapi/service/information/mapCoordinate', 'GET', searchParams);
    },




}